import { render, staticRenderFns } from "./Salary.vue?vue&type=template&id=b0d10bea&scoped=true&"
import script from "./Salary.vue?vue&type=script&lang=js&"
export * from "./Salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d10bea",
  null
  
)

export default component.exports